// extracted by mini-css-extract-plugin
export default {"container":"qiUfF","post":"Cljln","hashtags":"QbHnb","separator":"LxCmh","content":"oOmVY","commentExcerpt":"_35MRW"};